import { Component, input } from '@angular/core';
import { AvatarFullscreenConfig } from '@shared/index';

@Component({
    selector: 'app-avatar-fullscreen-header',
    imports: [],
    standalone: true,
    templateUrl: './avatar-fullscreen-header.component.html',
    styleUrl: './avatar-fullscreen-header.component.scss'
})
export class AvatarFullscreenHeaderComponent {
    public readonly header = input<AvatarFullscreenConfig['header'] | undefined>(undefined);

    public get hasContent(): boolean {
        const header = this.header();
        if (!header) return false;
        return header.left.kind !== 'none' || header.center.kind !== 'none' || header.right.kind !== 'none';
    }
}
